/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export interface PrescriptionPharmacyAddress {
  lines?: string[];
  city?: string | null;
  state?: string | null;
  postal_code?: string | null;
  country?: string | null;
}
